import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// project imports
import useAuth from "hooks/useAuth";
import LoadPage from "views/authentication/page";

const getQueryVariable = function (variable) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ props, children }) => {
  const { isLoggedIn, isInitialized, user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [load, setLoad] = useState(true);

  useEffect(() => {
    // Vuelta desde el portal con el token en la URL: LoginPage lo canjea
    if (getQueryVariable("csrfToken")) {
      setLoad(false);
      return;
    }
    // Firebase todavía no resuelve si hay sesión guardada
    if (!isInitialized) {
      return;
    }
    setLoad(false);
    // Sin sesión se va siempre al login, aunque quede un csrfToken guardado:
    // LoginPage intenta reautenticar con él o redirige al portal. Antes se
    // esperaba aquí y, si el token había quedado sin sesión de Firebase, la
    // app no salía nunca de la pantalla de carga.
    if (!isLoggedIn && pathname !== "/login") {
      navigate("/login");
    }
    if (isLoggedIn && user && pathname === "/login") {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isInitialized, navigate]);

  return !load ? children : <LoadPage></LoadPage>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
